exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index_textContainer_377OM {\n  width: 1200px;\n  margin: 0 auto;\n  padding: 12px;\n  box-sizing: border-box;\n  color: #333;\n  background-color: #fff;\n}\n\n.index_textContainer_377OM > div {\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n}\n\n.index_textContainer_377OM > div .ql-container {\n  border: none;\n}\n\n.index_textContainer_377OM > div .ql-container .ql-editor {\n  margin: 0;\n  padding: 0;\n}\n", ""]);

// Exports
exports.locals = {
	"textContainer": "index_textContainer_377OM"
};